import React from "react";
import { Check, X, Link2 } from "lucide-react";

/** Student-facing citation-linking table: every in-text citation and whether it
 *  resolves to a bibliography entry — an editing assistant, not just a stat. */
export const CitationLinks = ({ links = [], unusedSamples = [] }) => {
  if (!links.length) return null;
  const missing = links.filter((l) => l.status !== "matched").length;
  return (
    <div data-testid="ext-citation-links-table">
      <p className="text-xs font-semibold uppercase tracking-wide text-zinc-500 mb-2 flex items-center gap-1.5">
        <Link2 size={13} className="text-indigo-500" />
        Citation matching
        <span className="font-normal text-zinc-400 normal-case tracking-normal">
          {links.length - missing} of {links.length} matched
        </span>
      </p>
      <div className="rounded-xl border border-zinc-200 overflow-hidden">
        <table className="w-full text-[12.5px]">
          <thead>
            <tr className="bg-zinc-50 text-left text-[11px] uppercase tracking-wide text-zinc-500">
              <th className="px-3 py-2 font-semibold">In-text citation</th>
              <th className="px-3 py-2 font-semibold">Reference found</th>
              <th className="px-3 py-2 font-semibold w-28">Status</th>
            </tr>
          </thead>
          <tbody>
            {links.map((l, i) => (
              <tr key={i} className={"border-t border-zinc-100 " + (l.status === "matched" ? "" : "bg-rose-50/50")}
                data-testid={`citation-link-row-${i}`}>
                <td className="px-3 py-1.5 font-medium text-zinc-800 whitespace-nowrap">{l.citation}</td>
                <td className="px-3 py-1.5 text-zinc-600">
                  {l.reference || <span className="text-zinc-400 italic">—</span>}
                </td>
                <td className="px-3 py-1.5">
                  {l.status === "matched" ? (
                    <span className="inline-flex items-center gap-1 text-emerald-700 font-medium">
                      <Check size={13} /> Matched
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 text-rose-700 font-medium">
                      <X size={13} /> Missing from bibliography
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {unusedSamples.length > 0 && (
        <p className="text-[11.5px] text-zinc-500 mt-2" data-testid="ext-unused-references-note">
          <span className="font-semibold text-zinc-600">Never cited in the body:</span>{" "}
          {unusedSamples.join(" · ")}
        </p>
      )}
    </div>
  );
};
